var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wysiwyg',_vm._b({attrs:{"html":_vm.value,"options":_vm.options},on:{"change":function($event){return _vm.$emit('input', $event)}}},'wysiwyg',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }